import { render, staticRenderFns } from "./ModalRegrasAgendaGarantiaMinima.vue?vue&type=template&id=168091d8&scoped=true"
import script from "./ModalRegrasAgendaGarantiaMinima.vue?vue&type=script&lang=ts"
export * from "./ModalRegrasAgendaGarantiaMinima.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegrasAgendaGarantiaMinima.vue?vue&type=style&index=0&id=168091d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168091d8",
  null
  
)

export default component.exports